import script from "./Ticket.vue?vue&type=script&setup=true&lang=js"
export * from "./Ticket.vue?vue&type=script&setup=true&lang=js"

import "./Ticket.vue?vue&type=style&index=0&id=19f8711a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f8711a"]])

export default __exports__